angular.module('dnecom')
    .controller('StoreGeneralSettingsController', ["$scope", "wizardModal", "$http", "notifications", "$timeout", function ($scope, wizardModal, $http, notifications, $timeout) {
        $scope.currency = TemplateData.value('currency');
        $scope.recalculationPedning = TemplateData.value('recalculationPending');
        $scope.requestedCurrency = null;
        $scope.isDomainSet = function() {
            return !!$scope.store.domain;
        };

        var TICK_TIME = 10000; // one minute

        if (!localStorage.getItem('cd-skip-info')) {
            wizardModal.open({
                templateUrl: 'upgradeModal.html',
                controller: 'UpgradeModalController',
                size: 'md',
            });
        }

        $scope.openCurrencyModal = function(event) {
            event.preventDefault();

            wizardModal.open({
                templateUrl: 'currencyModal.html',
                controller: 'StoreCurrencyModalController',
                size: 'md',
            }).result.then(function(result) {
                $scope.requestedCurrency = result.currency;
                $http.get(
                    Routing.generate(
                        'stores_fe_api_currencies_rate',
                        { code: $scope.requestedCurrency.code }
                    )
                ).then(function(response) {
                    wizardModal.open({
                        templateUrl: 'currencyModalFinal.html',
                        windowClass: 'modal-danger',
                        size: 'md',
                        controller: function($scope, $uibModalInstance, $http, currency, rate) {
                            $scope.rate = rate.toFixed(2);
                            $scope.currency = currency;

                            $scope.closeModal = function () {
                                $uibModalInstance.dismiss();
                            };
                            $scope.saveCurrency = function () {
                                $uibModalInstance.close({rate: rate});
                            };
                        },
                        resolve: {
                            currency: function() {
                                return $scope.requestedCurrency;
                            },
                            rate: function() {
                                return response.data;
                            }
                        }
                    }).result.then(function(result) {
                        $http.post(
                            Routing.generate(
                                'stores_request_currency_recalculation',
                                { id: $scope.store.id }
                            ),
                            {
                               rate: result.rate,
                               currency: $scope.requestedCurrency.code
                            }
                        ).then(function(response) {
                            $scope.currency = $scope.requestedCurrency;
                            $scope.recalculationPedning = true;
                            $timeout(tick, TICK_TIME);
                            notifications.success('Primary currency updated.');
                        },
                        function(response) {
                            notifications.danger('Something went wrong. Please try again later');
                        });
                    });
                });
            });
        };

        var tick = function() {
            if ($scope.recalculationPedning) {
                $http
                    .get(
                        Routing.generate('stores_check_recalculation', { id: $scope.store.id })
                    )
                    .then(function(response) {
                        $scope.recalculationPedning = response.data;
                        if ($scope.recalculationPedning) {
                            $timeout(tick, TICK_TIME);
                        }
                    })
                ;
            }
        };

        if ($scope.recalculationPedning) {
            $timeout(tick, TICK_TIME);
        }

        $scope.changeDisplayStubOnMainState = function () {
            $scope.store.properties.general.displayStabOnMain = !$scope.store.properties.general.displayStabOnMain;
        };
    }]);
